module.exports = __webpack_public_path__ + "img/location.58110c1a.png";